/* eslint-disable react/destructuring-assignment,react/no-access-state-in-setstate,max-lines,class-methods-use-this,react/no-unused-state */
import React, { Component } from 'react'

import Table from '@trendmicro/react-table'
import { orderBy, get, isEqual } from 'lodash'
import PropTypes from 'prop-types'
import '@trendmicro/react-table/dist/react-table.css'
import ReactPaginate from 'react-paginate'
import './styles/grid.scss'

require('font-awesome/css/font-awesome.min.css')

class Grid extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sortColumnKey: this.props.defaultSortableKey,
      defaultSortOrder: this.props.sortOrder,
      sortOrder: this.props.defaultSortOrder,
      originalData: this.props.data,
      sortedData: [],
      displayData: [],
      columns: this.props.columns,
      pageCount: Math.ceil(this.props.data.length / this.props.pageLength),
      page: this.props.setPage,
      forcePage: undefined,
    }

    this.onLoad = this.onLoad.bind(this)
    this.onDataChange = this.onDataChange.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onColumnChange = this.onColumnChange.bind(this)
    this.onSort = this.onSort.bind(this)
    this.sortData = this.sortData.bind(this)
    this.getPagedRecord = this.getPagedRecord.bind(this)
  }

  componentDidMount() {
    this.onLoad()
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.data, prevProps.data)) {
      this.onDataChange()
    }

    if (!isEqual(this.props.columns, prevProps.columns)) {
      this.onColumnChange()
    }
  }

  onLoad() {
    const { defaultSortableKey, defaultSortOrder } = this.props

    const formattedColumns = this.props.columns.map(column => {
      if (column.sortable) {
        return {
          ...column,
          sortOrder: column.key === defaultSortableKey ? defaultSortOrder : '',
          onClick: this.onSort(column),
        }
      }
      return column
    })
    const sortedData = this.sortData(
      this.props.data,
      defaultSortableKey,
      defaultSortOrder
    )
    const pagedData = this.getPagedRecord(sortedData, this.state.page)

    this.setState({
      sortedData,
      displayData: this.props.clientSidePagination ? pagedData : sortedData,
      pageCount: Math.ceil(
        this.props.data && this.props.data.length / this.props.pageLength
      ),
      columns: formattedColumns,
    })
  }

  onDataChange() {
    const sortedData = this.sortData(
      this.props.data,
      this.state.sortColumnKey,
      this.state.sortOrder
    )
    const pagedData = this.getPagedRecord(
      this.state.sortColumnKey ? sortedData : this.state.originalData,
      0
    )

    this.setState({
      sortedData,
      displayData: this.props.clientSidePagination ? pagedData : sortedData,
      pageCount: Math.ceil(
        this.props.data && this.props.data.length / this.props.pageLength
      ),
      forcePage: 0,
    })
  }

  onPageChange({ selected }) {
    this.setState({
      displayData: this.getPagedRecord(this.state.sortedData, selected),
      pageCount: Math.ceil(
        this.state.sortedData.length / this.props.pageLength
      ),
      page: selected,
      forcePage: undefined,
    })
  }

  onColumnChange() {
    const { sortColumnKey, sortOrder } = this.state

    const newColumns = this.props.columns.map(column => ({
      ...column,
      sortOrder: column.key === sortColumnKey ? sortOrder : '',
    }))

    this.setState({ columns: newColumns })
  }

  onSort(column) {
    return () => {
      const allSortOrders = ['', 'asc', 'desc']
      const sortIndex = allSortOrders.findIndex(i => i === this.state.sortOrder)
      const order =
        this.state.sortColumnKey !== column.key
          ? 'asc'
          : allSortOrders[(sortIndex + 1) % 3]

      const sortOrder = order || this.props.defaultSortOrder
      const sortColumnKey = order ? column.key : this.props.defaultSortableKey

      const newColumns = this.state.columns.map(c => ({
        ...c,
        sortOrder: c.key === sortColumnKey ? sortOrder : '',
      }))
      const sortedData = this.sortData(
        this.props.data,
        sortColumnKey,
        sortOrder
      )

      const toPage =
        // eslint-disable-next-line no-nested-ternary
        this.state.forcePage === 0
          ? 0
          : this.state.page >= this.state.pageCount
          ? this.state.pageCount - 1
          : this.state.page

      const displayData = this.getPagedRecord(sortedData, toPage)

      this.props.collapseOpenRecords()
      this.setState({
        sortColumnKey,
        sortOrder,
        columns: newColumns,
        sortedData,
        displayData,
      })
    }
  }

  getPagedRecord(data, page) {
    const start = page * this.props.pageLength
    const end = start + this.props.pageLength

    return data && data.slice(start, end)
  }

  sortData(data, sortedColumn, sortOrder) {
    const iteratee = item => {
      const value = get(item, sortedColumn)
      return value && value.toString().toLowerCase().replace(/\s/g, '')
    }

    return orderBy(data, [iteratee], [sortOrder])
  }

  render() {
    return (
      <>
        {this.props.clientSidePagination ? (
          <ReactPaginate
            previousLabel="prev"
            nextLabel="next"
            breakLabel="..."
            breakClassName="break-me"
            pageCount={this.state.pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            onPageChange={this.onPageChange}
            containerClassName="pagination"
            subContainerClassName="pages pagination"
            activeClassName="active"
            forcePage={this.state.forcePage}
            initialPage={0}
          />
        ) : null}
        <Table
          columns={this.state.columns}
          data={this.state.displayData}
          bordered
          hoverable={this.props.hoverable}
          justified={this.props.justified}
          rowKey={this.props.rowKey}
          useFixedHeader={this.props.useFixedHeader}
          maxHeight={this.props.maxHeight ? this.props.maxHeight : null}
          rowClassName={
            this.props.rowClassName
              ? this.props.rowClassName
              : () => 'table-row'
          }
          onRowClick={this.props.onRowClick ? this.props.onRowClick : () => {}}
          emptyText={() => 'No data found'}
          expandedRowRender={
            this.props.expandedRowRender
              ? this.props.expandedRowRender
              : () => {}
          }
          expandedRowKeys={
            this.props.expandedRowKeys ? this.props.expandedRowKeys : []
          }
        />
      </>
    )
  }
}

Grid.propTypes = {
  sortOrder: PropTypes.oneOf(['asc', 'desc']),
  defaultSortableKey: PropTypes.string,
  defaultSortOrder: PropTypes.string,
  clientSidePagination: PropTypes.bool,
  pageLength: PropTypes.number,
  collapseOpenRecords: PropTypes.func,
  setPage: PropTypes.number,
}

Grid.defaultProps = {
  sortOrder: 'asc',
  defaultSortOrder: 'asc',
  defaultSortableKey: null,
  clientSidePagination: false,
  columns: [],
  pageLength: 10,
  collapseOpenRecords: () => {},
  setPage: 0,
}

export default Grid
